import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { StoryboardService } from 'app/services/storyboard.service';
import { Storyboard } from 'app/models/storyboard';
import { File } from 'app/models/file';
@Component({
  selector: 'app-storyboard',
  templateUrl: './storyboard.component.html',
  styleUrls: ['./storyboard.component.scss']
})
export class StoryboardComponent implements OnInit {
  storyboard: Storyboard;
  file: File;

  constructor(
    private storyboardService: StoryboardService,
    private activatedRoute: ActivatedRoute
  ) {}

  change(event): void {
    this.file = event;
  }

  private getStoryboard(id: string): void {
    this.storyboardService.getById(id).subscribe(res => {
      this.storyboard = res;
      this.storyboard.files.map(f => {
          f.containerId = this.storyboard.id;
          return f;

})
      this.file = this.storyboard.files[0];
    });
  }

  private getParamName(): void {
    this.activatedRoute.params.subscribe((params: any) => {
      this.getStoryboard(params.id);
    });
  }

  ngOnInit() {
    this.getParamName();
  }
}
